import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
    ModelEvents,
} from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../../AnimationContents';
import { ButtonController } from '../../../Common/ButtonController';
import { GameModel } from '../../../Models/GameModel';
import { Container, Sprite, Texture } from 'pixi.js';
import { IPictureTexture } from '../../Screens/Catalog/CatalogFolderController';
import {
    BlueButtonTextStyle,
    GreenButtonTextStyle,
    TitleTextStyle,
    YellowTextBoldStyle,
} from '../../../Constants/TextStyles';
import { GameEvent, GameEventPopupButtonName, GameEventPopupName } from '../../../Constants/GameEvent';

export enum ConfirmationsYouRewardType {
    picture = 'picture',
    needle = 'needle',
    yarn = 'yarn',
    bucket = 'bucket',
    combo = 'combo',
    combo_3x = 'combo_3x',
    money = 'money',
}

export interface IConfirmationsYouRewardControllerOptions {
    type: ConfirmationsYouRewardType;
    texture?: IPictureTexture;
    value?: number[] | number;
    text?: 'A you sure?';
    okText?: 'OK';
    okClick?: () => {};
    exitClick?: () => {};
    skipAnalytics?: boolean;
}

export class ConfirmationsYouRewardController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options: IConfirmationsYouRewardControllerOptions,
        @Inject private modelEvents: ModelEvents,
        @Inject private model: GameModel,
    ) {
        super('ConfirmationsYouRewardController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.CONFIRMATIONS_JSON,
            libraryName: 'confirmations_container',
            childControllers: {
                your_reward_ok: {
                    controller: ButtonController,
                    instanceName: 'confirmations.your_reward.your_reward_ok',
                    options: {
                        label: this._options.okText || '',
                        onClick: () => {
                            if (!this._options.skipAnalytics) {
                                this.modelEvents.dispatch(this.model, GameEvent.popupButtonClick, {
                                    popupName: GameEventPopupName.youReward,
                                    buttonName: GameEventPopupButtonName.thanks
                                });
                            }

                            if (this._options.okClick) {
                                this._options.okClick();
                            }
                        },
                    },
                },
                you_reward_exit: {
                    controller: ButtonController,
                    instanceName: 'confirmations.your_reward.you_reward_exit',
                    options: {
                        onClick: () => {
                            if (!this._options.skipAnalytics) {
                                this.modelEvents.dispatch(this.model, GameEvent.popupButtonClick, {
                                    popupName: GameEventPopupName.youReward,
                                    buttonName: GameEventPopupButtonName.close
                                });
                            }

                            if (this._options.exitClick) {
                                this._options.exitClick();
                            }
                        },
                    },
                },
            },
        };
    }

    protected onInitialize() {
        this.init();
    }

    protected onResize(width: number, height: number, scale: number) {
    }

    public init(): void {
        let type =  this._options.type as any;
        if (type === 'yarn') {
            type = 'yarm';
        }

        this.gotoAndStopByQuery('confirmations', 'your_reward');
        this.gotoAndStopByQuery('confirmations.your_reward.your_reward_icon', type);

        this.setTextByQuery('confirmations.your_reward.your_reward_title', this._options.text || '');
        this.setTextStyleByQuery('confirmations.your_reward.your_reward_title', TitleTextStyle);

        this.setTextVerticalAlignByQuery('confirmations.your_reward.your_reward_title', 'middle');

        this.setTextByQuery('confirmations.your_reward.your_reward_ok.label', this._options.okText || '');
        this.setTextByQuery('confirmations.your_reward.your_reward_ok.txt_price', this._options.okText || '');

        this.setTextStyleByQuery('confirmations.your_reward.your_reward_ok.label', GreenButtonTextStyle);
        this.setTextStyleByQuery('confirmations.your_reward.your_reward_ok.txt_price', GreenButtonTextStyle);

        this.setTextStyleByQuery('confirmations.your_reward.your_reward_icon.txt_value', YellowTextBoldStyle);
        this.setTextStyleByQuery('confirmations.your_reward.your_reward_icon.txt_value1', YellowTextBoldStyle);
        this.setTextStyleByQuery('confirmations.your_reward.your_reward_icon.txt_value2', YellowTextBoldStyle);

        switch (this._options.type) {
            case ConfirmationsYouRewardType.picture:
                const texture = this._options.texture || null;

                if (texture) {
                    const placeholder = ((this.getDisplayObjectByQuery('confirmations.your_reward.your_reward_icon.icon_minipicture')[0] as Container).getChildAt(0) as Sprite);
                    placeholder.texture = texture.texture;
                    placeholder.width = 241;
                    placeholder.height = 241;
                }
                this.setTextByQuery('confirmations.your_reward.your_reward_icon.txt_value', `${Array.isArray(this._options.value) ? this._options.value[0].toString() : this._options.value.toString()}`);
                break;

            case ConfirmationsYouRewardType.needle:
            case ConfirmationsYouRewardType.yarn:
            case ConfirmationsYouRewardType.bucket:
                this.setTextByQuery('confirmations.your_reward.your_reward_icon.txt_value', `x${Array.isArray(this._options.value) ? this._options.value[0].toString() : this._options.value.toString()}`);
                break;

            case ConfirmationsYouRewardType.money:
                this.setTextByQuery('confirmations.your_reward.your_reward_icon.txt_value', `x${Array.isArray(this._options.value) ? this._options.value[0].toString() : this._options.value.toString()}`);
                this.setTextStyleByQuery('confirmations.your_reward.your_reward_icon.txt_value', YellowTextBoldStyle);
                break;

            case ConfirmationsYouRewardType.combo:
                this.setTextByQuery('confirmations.your_reward.your_reward_icon.txt_value1', `x${this._options.value[0].toString()}` || '');
                this.setTextByQuery('confirmations.your_reward.your_reward_icon.txt_value2', `x${this._options.value[1].toString()}` || '');
                break;

            case ConfirmationsYouRewardType.combo_3x:
                this.setTextByQuery('confirmations.your_reward.your_reward_icon.txt_value', `x${Array.isArray(this._options.value) ? this._options.value[0].toString() : this._options.value.toString()}`);
                break;
        }
    }
}
